// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-primary {
  color: #662d91;
}
.bg-primary {
  background-color: #662d91;
}
.bg-secondary {
  background-color: #f6f6f2 !important;
}
.error-text {
  color: #d14e4e;
}
.success-text {
  color: #65d14e;
}
.info-text {
  color: #4eb9d1;
}
.warning-text {
  color: #d1a44e;
}
.custom-border {
  border-color: rgba(102, 45, 145, 0.5) !important;
}
/* call to action main button  */
.cta-one {
  text-wrap: nowrap;
  border: initial;
  z-index: 1;
  background-color: #662d91;
  position: relative;
  transition: all 200ms;
  overflow: hidden;
  font-weight: 600;
  color: #f6f6f2;
  border: 1px solid #662d91;
}
.cta-one::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 0;
  background: transparent;
  background-color: #2a133c;
  z-index: -1;
  box-shadow: 4px 8px 19px -3px rgba(0, 0, 0, 0.27);
  transition: all 200ms;
}
.cta-one:hover {
  color: #f6f6f2;
}
.cta-one:hover::before {
  width: 100%;
}

/* call to action secondary button  */
.cta-two {
  text-wrap: nowrap;
  border: initial;
  z-index: 1;
  border: 1px solid #662d91;
  background: transparent;
  position: relative;
  transition: all 200ms;
  overflow: hidden;
  font-weight: 600;
}
.cta-two::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 0;
  background-color: #662d91;
  z-index: -1;
  box-shadow: 4px 8px 19px -3px rgba(0, 0, 0, 0.27);
  transition: all 200ms;
}
.cta-two:hover {
  color: #f6f6f2;
}
.cta-two:hover::before {
  width: 100%;
}
/* Navbar links */
.nav-link {
  cursor: pointer;
  position: relative;
  border: none;
  background: none;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-duration: 400ms;
  transition-property: color;
}
.nav-link:focus,
.nav-link:hover {
  color: #662d91;
}
.nav-link:focus:after,
.nav-link:hover:after {
  width: 100%;
  left: 0%;
}
.nav-link:after {
  content: "";
  pointer-events: none;
  bottom: -2px;
  left: 0;
  position: absolute;
  width: 0%;
  height: 2px;
  background-color: #662d91;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-duration: 400ms;
  transition-property: width, left;
}
/* General container */
.card {
  background-color: #f6f6f2;
  border: 1px solid rgba(102, 45, 145, 0.4);
}
.menu-tray li {
  border-radius: 100px;
  width: 100%;
  height: 100%;
}
.menu-tray li:hover {
  background-color: rgba(102, 45, 145, 0.07);
}

/* Multi range slider custom css */
.multi-range-slider {
  /* background-color: transparent !important; */
  box-shadow: none !important;
  border: none !important;
  padding: 10px !important;
}

.multi-range-slider .ruler {
  display: none !important;
}

.multi-range-slider .label {
  display: none !important;
}

.multi-range-slider .bar-left {
  border: 1px solid #662d91 !important;
  background-color: transparent !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  padding: 2px 0 !important;
}

.multi-range-slider .bar-inner {
  background-color: #662d91 !important;
  border: 0 !important;
  box-shadow: none !important;
}

.multi-range-slider .bar-right {
  border: 1px solid #662d91 !important;
  background-color: transparent !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  padding: 2px 0 !important;
}
.multi-range-slider .thumb {
  background-color: #662d91 !important;
  cursor: grab;
}
.multi-range-slider .thumb::before {
  border: none !important;
  box-shadow: none !important;
  width: 16px !important;
  height: 16px !important;
  top: 50%;
  margin: -8px !important;
}

.multi-range-slider .thumb .caption * {
  display: none;
}
.active {
  background-color: #662d91;
  color: #fff;
}
.break-line {
  height: 30px;
  width: 1px;
  background-color: rgba(102, 45, 145, 0.5);
}

/* Footer */
.app-footer {
  padding: 0 !important;
  border: none !important;
  background: transparent;
}

.footer {
  background: transparent;
  /* padding-top: 80px; */
  /* padding-bottom: 40px; */
}

.footer-contact {
}

.footer-contact svg {
  font-size: 22px;
}

.footer-contact p {
  margin: 0 0 0 14px;
  line-height: 20px !important;
}

.social-icon-section {
  justify-content: center;
}

@media only screen and (min-width: 992px) {
  .social-icon-section {
    justify-content: flex-start;
  }
}

.social-icon-section svg {
  color: #fff;
  font-size: 35px;
  margin-right: 30px;
}

.social-icon-section img {
  width: 35px;
  margin-right: 30px;
}

@media only screen and (max-width: 768px) {
  .single_footer {
    margin-bottom: 30px;
  }
}

.single_footer h4 {
  color: #fff;
  margin-top: 0;
  margin-bottom: 25px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 16px;
}

.single_footer h4::after {
  content: "";
  display: block;
  height: 2px;
  width: 40px;
  background: #fff;
  margin-top: 20px;
}

.single_footer p {
  color: #fff;
  line-height: 36px;
}

.single_footer ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.single_footer ul li a {
  color: #fff !important;
  transition: all 0.3s ease 0s;
  line-height: 36px;
  font-size: 15px;
  text-transform: capitalize;
  cursor: pointer;
}

.single_footer ul li a:hover {
  text-decoration: underline !important;
  /* color: rgb(1, 32, 78); */
}

.single_footer_address ul li {
  color: #fff;
}

.single_footer_address ul li span {
  font-weight: 400;
  color: #fff;
  line-height: 28px;
}

.contact_social ul {
  list-style: outside none none;
  margin: 0;
  padding: 0;
}

.subscribe {
  display: block;
  position: relative;
  margin-top: 15px;
  width: 100%;
}

.subscribe__input {
  background-color: transparent;
  border: 1px solid #333;
  border-radius: 5px;
  color: #fff;
  display: block;
  font-size: 15px;
  font-weight: 500;
  height: 40px;
  letter-spacing: 0.4px;
  margin: 0;
  padding: 0 150px 0 20px;
  /* text-align: center; */
  text-transform: capitalize;
  width: 100%;
}

@media only screen and (max-width: 768px) {
  .subscribe__input {
    padding: 0 50px 0 20px;
  }
}

.subscribe__btn {
  background-color: #662d91;
  border-radius: 0 5px 5px 0;
  color: #a247e6;
  cursor: pointer;
  display: block;
  font-size: 20px;
  height: 40px;
  position: absolute;
  right: 0;
  top: 0;
  width: 60px;
}

.subscribe__btn i {
  transition: all 0.3s ease 0s;
}

@media only screen and (max-width: 768px) {
  .subscribe__btn {
    right: 0px;
  }
}

.subscribe__btn:hover i {
  color: #a247e6;
}

button {
  padding: 0;
  border: none;
  background-color: transparent;
  border-radius: 0;
}

.social_profile {
  margin-top: 40px;
}

.social_profile ul {
  list-style: outside none none;
  margin: 0;
  padding: 0;
}

.social_profile ul li {
  float: left;
}

.social_profile ul li a {
  text-align: center;
  border: 0px;
  text-transform: uppercase;
  transition: all 0.3s ease 0s;
  margin: 0px 5px;
  font-size: 18px;
  color: #fff;
  border-radius: 30px;
  width: 50px;
  height: 50px;
  line-height: 50px;
  display: block;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

@media only screen and (max-width: 768px) {
  .social_profile ul li a {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

@media only screen and (max-width: 480px) {
  .social_profile ul li a {
    width: 40px;
    height: 40px;
    line-height: 40px;
  }
}

.social_profile ul li a:hover {
  background: #a247e6;
  border: 1px solid #a247e6;
  color: #fff;
  border: 0px;
}

.copyright-section {
  margin-top: 70px;
}

.copyright {
  margin: 0;
  padding: 16px 0;
  color: #fff;
  font-size: 15px;
  text-align: center;
}

.copyright a {
  color: #a247e6;
  transition: all 0.2s ease 0s;
}

.copyright a:hover {
  color: #a247e6;
}

.copyright-logo {
  width: 40px;
  margin: 0 20px;
}

/* UI Animations */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}

.animate-fade-in {
  animation: fadeIn 1.6s ease-out forwards;
}

.animate-slide-up {
  animation: slideUp 1.2s ease-out forwards;
  opacity: 0; /* Start hidden for slide effects */
}

.animate-slide-down {
  animation: slideDown 1.2s ease-out forwards;
  opacity: 0;
}

.delay-100 { animation-delay: 0.1s; }
.delay-200 { animation-delay: 0.2s; }
.delay-300 { animation-delay: 0.3s; }
.delay-400 { animation-delay: 0.4s; }
.delay-500 { animation-delay: 0.5s; }

/* Login Page Background Animation - Removed as per user request */
/* @keyframes kenburns removed */

.login-bg-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;
}

.login-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* animation: kenburns 30s ease-in-out infinite alternate; */
}

/* Glassmorphism */
.glass-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
}

.glass-modal .modal-content {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(15px) !important;
  -webkit-backdrop-filter: blur(15px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-radius: 2rem !important;
}

/* Animations */
@keyframes subtleZoom {
  from { transform: scale(1); }
  to { transform: scale(1.1); }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-subtle-zoom {
  animation: subtleZoom 40s ease-in-out infinite alternate;
}

.animate-fade-in-up {
  animation: fadeInUp 2s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
}

@keyframes shine {
  0% { transform: translateX(-100%) skewX(-15deg); }
  50% { transform: translateX(100%) skewX(-15deg); }
  100% { transform: translateX(100%) skewX(-15deg); }
}

.animate-shine {
  position: relative;
  overflow: hidden;
}

.animate-shine::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: shine 6s infinite;
}

/* ── Editorial Calm — Hero Pill Slide-In ──────────────────── */

@keyframes slideFromLeft {
  from {
    opacity: 0;
    transform: translateX(-40px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.hero-pill {
  opacity: 0;
  animation: slideFromLeft 1.2s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
}

/* ── Universal Scroll Reveal ──────────────────────────────── */

.scroll-reveal {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 1.2s cubic-bezier(0.2, 0.8, 0.2, 1),
              transform 1.2s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.scroll-reveal.is-visible {
  opacity: 1;
  transform: translateY(0);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gDAAgD;AAClD;AACA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,eAAa;EACb,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,QAAQ;EACR,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EAEX,iDAAiD;EACjD,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;EACjB,eAAa;EACb,UAAU;EACV,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,WAAW;EAEX,iDAAiD;EACjD,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA,iBAAiB;AACjB;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,4DAA4D;EAC5D,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,QAAQ;AACV;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,4DAA4D;EAC5D,0BAA0B;EAC1B,gCAAgC;AAClC;AACA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;AACA;EACE,0CAA0C;AAC5C;;AAEA,kCAAkC;AAClC;EACE,8CAA8C;EAC9C,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,YAAY;EACZ,UAAU;EACV,yCAAyC;AAC3C;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;AACA;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EAEtB,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,6BAA6B;EAE7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,UAAU,EAAE,mCAAmC;AACjD;;AAEA;EACE,2CAA2C;EAC3C,UAAU;AACZ;;AAEA,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;;AAEpC,kEAAkE;AAClE,gCAAgC;;AAEhC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4DAA4D;AAC9D;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;EAC/C,sCAAsC;EACtC,8CAA8C;EAC9C,qDAAqD;EACrD,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,OAAO,mBAAmB,EAAE;EAC5B,KAAK,qBAAqB,EAAE;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,KAAK,0CAA0C,EAAE;EACjD,MAAM,yCAAyC,EAAE;EACjD,OAAO,yCAAyC,EAAE;AACpD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;EACZ;;;;;GAKC;EACD,4BAA4B;AAC9B;;AAEA,gEAAgE;;AAEhE;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,UAAU;EACV,qEAAqE;AACvE;;AAEA,gEAAgE;;AAEhE;EACE,UAAU;EACV,2BAA2B;EAC3B;2DACyD;AAC3D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B","sourcesContent":[".text-primary {\n  color: #662d91;\n}\n.bg-primary {\n  background-color: #662d91;\n}\n.bg-secondary {\n  background-color: #f6f6f2 !important;\n}\n.error-text {\n  color: #d14e4e;\n}\n.success-text {\n  color: #65d14e;\n}\n.info-text {\n  color: #4eb9d1;\n}\n.warning-text {\n  color: #d1a44e;\n}\n.custom-border {\n  border-color: rgba(102, 45, 145, 0.5) !important;\n}\n/* call to action main button  */\n.cta-one {\n  text-wrap: nowrap;\n  border: unset;\n  z-index: 1;\n  background-color: #662d91;\n  position: relative;\n  transition: all 200ms;\n  overflow: hidden;\n  font-weight: 600;\n  color: #f6f6f2;\n  border: 1px solid #662d91;\n}\n.cta-one::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 0;\n  background: transparent;\n  background-color: #2a133c;\n  z-index: -1;\n  -webkit-box-shadow: 4px 8px 19px -3px rgba(0, 0, 0, 0.27);\n  box-shadow: 4px 8px 19px -3px rgba(0, 0, 0, 0.27);\n  transition: all 200ms;\n}\n.cta-one:hover {\n  color: #f6f6f2;\n}\n.cta-one:hover::before {\n  width: 100%;\n}\n\n/* call to action secondary button  */\n.cta-two {\n  text-wrap: nowrap;\n  border: unset;\n  z-index: 1;\n  border: 1px solid #662d91;\n  background: transparent;\n  position: relative;\n  transition: all 200ms;\n  overflow: hidden;\n  font-weight: 600;\n}\n.cta-two::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 0;\n  background-color: #662d91;\n  z-index: -1;\n  -webkit-box-shadow: 4px 8px 19px -3px rgba(0, 0, 0, 0.27);\n  box-shadow: 4px 8px 19px -3px rgba(0, 0, 0, 0.27);\n  transition: all 200ms;\n}\n.cta-two:hover {\n  color: #f6f6f2;\n}\n.cta-two:hover::before {\n  width: 100%;\n}\n/* Navbar links */\n.nav-link {\n  cursor: pointer;\n  position: relative;\n  border: none;\n  background: none;\n  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);\n  transition-duration: 400ms;\n  transition-property: color;\n}\n.nav-link:focus,\n.nav-link:hover {\n  color: #662d91;\n}\n.nav-link:focus:after,\n.nav-link:hover:after {\n  width: 100%;\n  left: 0%;\n}\n.nav-link:after {\n  content: \"\";\n  pointer-events: none;\n  bottom: -2px;\n  left: 0;\n  position: absolute;\n  width: 0%;\n  height: 2px;\n  background-color: #662d91;\n  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);\n  transition-duration: 400ms;\n  transition-property: width, left;\n}\n/* General container */\n.card {\n  background-color: #f6f6f2;\n  border: 1px solid rgba(102, 45, 145, 0.4);\n}\n.menu-tray li {\n  border-radius: 100px;\n  width: 100%;\n  height: 100%;\n}\n.menu-tray li:hover {\n  background-color: rgba(102, 45, 145, 0.07);\n}\n\n/* Multi range slider custom css */\n.multi-range-slider {\n  /* background-color: transparent !important; */\n  box-shadow: none !important;\n  border: none !important;\n  padding: 10px !important;\n}\n\n.multi-range-slider .ruler {\n  display: none !important;\n}\n\n.multi-range-slider .label {\n  display: none !important;\n}\n\n.multi-range-slider .bar-left {\n  border: 1px solid #662d91 !important;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  padding: 2px 0 !important;\n}\n\n.multi-range-slider .bar-inner {\n  background-color: #662d91 !important;\n  border: 0 !important;\n  box-shadow: none !important;\n}\n\n.multi-range-slider .bar-right {\n  border: 1px solid #662d91 !important;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  padding: 2px 0 !important;\n}\n.multi-range-slider .thumb {\n  background-color: #662d91 !important;\n  cursor: grab;\n}\n.multi-range-slider .thumb::before {\n  border: none !important;\n  box-shadow: none !important;\n  width: 16px !important;\n  height: 16px !important;\n  top: 50%;\n  margin: -8px !important;\n}\n\n.multi-range-slider .thumb .caption * {\n  display: none;\n}\n.active {\n  background-color: #662d91;\n  color: #fff;\n}\n.break-line {\n  height: 30px;\n  width: 1px;\n  background-color: rgba(102, 45, 145, 0.5);\n}\n\n/* Footer */\n.app-footer {\n  padding: 0 !important;\n  border: none !important;\n  background: transparent;\n}\n\n.footer {\n  background: transparent;\n  /* padding-top: 80px; */\n  /* padding-bottom: 40px; */\n}\n\n.footer-contact {\n}\n\n.footer-contact svg {\n  font-size: 22px;\n}\n\n.footer-contact p {\n  margin: 0 0 0 14px;\n  line-height: 20px !important;\n}\n\n.social-icon-section {\n  justify-content: center;\n}\n\n@media only screen and (min-width: 992px) {\n  .social-icon-section {\n    justify-content: flex-start;\n  }\n}\n\n.social-icon-section svg {\n  color: #fff;\n  font-size: 35px;\n  margin-right: 30px;\n}\n\n.social-icon-section img {\n  width: 35px;\n  margin-right: 30px;\n}\n\n@media only screen and (max-width: 768px) {\n  .single_footer {\n    margin-bottom: 30px;\n  }\n}\n\n.single_footer h4 {\n  color: #fff;\n  margin-top: 0;\n  margin-bottom: 25px;\n  font-weight: 700;\n  text-transform: uppercase;\n  font-size: 16px;\n}\n\n.single_footer h4::after {\n  content: \"\";\n  display: block;\n  height: 2px;\n  width: 40px;\n  background: #fff;\n  margin-top: 20px;\n}\n\n.single_footer p {\n  color: #fff;\n  line-height: 36px;\n}\n\n.single_footer ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.single_footer ul li a {\n  color: #fff !important;\n  -webkit-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n  line-height: 36px;\n  font-size: 15px;\n  text-transform: capitalize;\n  cursor: pointer;\n}\n\n.single_footer ul li a:hover {\n  text-decoration: underline !important;\n  /* color: rgb(1, 32, 78); */\n}\n\n.single_footer_address ul li {\n  color: #fff;\n}\n\n.single_footer_address ul li span {\n  font-weight: 400;\n  color: #fff;\n  line-height: 28px;\n}\n\n.contact_social ul {\n  list-style: outside none none;\n  margin: 0;\n  padding: 0;\n}\n\n.subscribe {\n  display: block;\n  position: relative;\n  margin-top: 15px;\n  width: 100%;\n}\n\n.subscribe__input {\n  background-color: transparent;\n  border: 1px solid #333;\n  border-radius: 5px;\n  color: #fff;\n  display: block;\n  font-size: 15px;\n  font-weight: 500;\n  height: 40px;\n  letter-spacing: 0.4px;\n  margin: 0;\n  padding: 0 150px 0 20px;\n  /* text-align: center; */\n  text-transform: capitalize;\n  width: 100%;\n}\n\n@media only screen and (max-width: 768px) {\n  .subscribe__input {\n    padding: 0 50px 0 20px;\n  }\n}\n\n.subscribe__btn {\n  background-color: #662d91;\n  border-radius: 0 5px 5px 0;\n  color: #a247e6;\n  cursor: pointer;\n  display: block;\n  font-size: 20px;\n  height: 40px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 60px;\n}\n\n.subscribe__btn i {\n  transition: all 0.3s ease 0s;\n}\n\n@media only screen and (max-width: 768px) {\n  .subscribe__btn {\n    right: 0px;\n  }\n}\n\n.subscribe__btn:hover i {\n  color: #a247e6;\n}\n\nbutton {\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.social_profile {\n  margin-top: 40px;\n}\n\n.social_profile ul {\n  list-style: outside none none;\n  margin: 0;\n  padding: 0;\n}\n\n.social_profile ul li {\n  float: left;\n}\n\n.social_profile ul li a {\n  text-align: center;\n  border: 0px;\n  text-transform: uppercase;\n  transition: all 0.3s ease 0s;\n  margin: 0px 5px;\n  font-size: 18px;\n  color: #fff;\n  border-radius: 30px;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  display: block;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n@media only screen and (max-width: 768px) {\n  .social_profile ul li a {\n    margin-right: 10px;\n    margin-bottom: 10px;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .social_profile ul li a {\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n  }\n}\n\n.social_profile ul li a:hover {\n  background: #a247e6;\n  border: 1px solid #a247e6;\n  color: #fff;\n  border: 0px;\n}\n\n.copyright-section {\n  margin-top: 70px;\n}\n\n.copyright {\n  margin: 0;\n  padding: 16px 0;\n  color: #fff;\n  font-size: 15px;\n  text-align: center;\n}\n\n.copyright a {\n  color: #a247e6;\n  transition: all 0.2s ease 0s;\n}\n\n.copyright a:hover {\n  color: #a247e6;\n}\n\n.copyright-logo {\n  width: 40px;\n  margin: 0 20px;\n}\n\n/* UI Animations */\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes slideDown {\n  from { opacity: 0; transform: translateY(-20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.animate-fade-in {\n  animation: fadeIn 1.6s ease-out forwards;\n}\n\n.animate-slide-up {\n  animation: slideUp 1.2s ease-out forwards;\n  opacity: 0; /* Start hidden for slide effects */\n}\n\n.animate-slide-down {\n  animation: slideDown 1.2s ease-out forwards;\n  opacity: 0;\n}\n\n.delay-100 { animation-delay: 0.1s; }\n.delay-200 { animation-delay: 0.2s; }\n.delay-300 { animation-delay: 0.3s; }\n.delay-400 { animation-delay: 0.4s; }\n.delay-500 { animation-delay: 0.5s; }\n\n/* Login Page Background Animation - Removed as per user request */\n/* @keyframes kenburns removed */\n\n.login-bg-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  overflow: hidden;\n}\n\n.login-bg-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  /* animation: kenburns 30s ease-in-out infinite alternate; */\n}\n\n/* Glassmorphism */\n.glass-card {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);\n}\n\n.glass-modal .modal-content {\n  background: rgba(255, 255, 255, 0.7) !important;\n  backdrop-filter: blur(15px) !important;\n  -webkit-backdrop-filter: blur(15px) !important;\n  border: 1px solid rgba(255, 255, 255, 0.3) !important;\n  border-radius: 2rem !important;\n}\n\n/* Animations */\n@keyframes subtleZoom {\n  from { transform: scale(1); }\n  to { transform: scale(1.1); }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-subtle-zoom {\n  animation: subtleZoom 40s ease-in-out infinite alternate;\n}\n\n.animate-fade-in-up {\n  animation: fadeInUp 2s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;\n}\n\n@keyframes shine {\n  0% { transform: translateX(-100%) skewX(-15deg); }\n  50% { transform: translateX(100%) skewX(-15deg); }\n  100% { transform: translateX(100%) skewX(-15deg); }\n}\n\n.animate-shine {\n  position: relative;\n  overflow: hidden;\n}\n\n.animate-shine::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(\n    to right,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.3) 50%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  animation: shine 6s infinite;\n}\n\n/* ── Editorial Calm — Hero Pill Slide-In ──────────────────── */\n\n@keyframes slideFromLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.hero-pill {\n  opacity: 0;\n  animation: slideFromLeft 1.2s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;\n}\n\n/* ── Universal Scroll Reveal ──────────────────────────────── */\n\n.scroll-reveal {\n  opacity: 0;\n  transform: translateY(24px);\n  transition: opacity 1.2s cubic-bezier(0.2, 0.8, 0.2, 1),\n              transform 1.2s cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n\n.scroll-reveal.is-visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
